import ProductImageStore from './ProductImageStore'

export default ProductImageStore
